// extracted by mini-css-extract-plugin
module.exports = {"cnnFooter":"Footer_cnnFooter__2_I4L","cnnFooter__link":"Footer_cnnFooter__link__1IUAJ","cnnFooter__footerInner":"Footer_cnnFooter__footerInner__36U62"};